import { map } from 'rxjs/operators';
import { FirebaseCollection } from './../_enums/firebaseCollection.enum';
import { AngularFirestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClinicService {
  constructor(private _angularFirestore: AngularFirestore) { }
  public  entities: any[] = [];
     
  get(docId: string) {
    return this._angularFirestore.collection(FirebaseCollection.CLINIC)
      .doc(docId).get()
      .pipe(map(snap => snap.data()));
  }

  set(docId: string, data: any) {
    return this._angularFirestore.collection(FirebaseCollection.CLINIC)
      .doc(docId).set(data, {
        merge: true
      });
  }

  async addInBulk(times) {
    try {
      const batch = this._angularFirestore.firestore.batch();
      times.forEach(async (doc: any) => {
        const userRef = this._angularFirestore
          .collection(FirebaseCollection.CLINIC)
          .doc(FirebaseCollection.OPERATING_HOUR)
          .collection('appointmentTimes')
          .doc()
          .ref;
        batch.set(userRef, { ...doc });
      });
      await batch.commit();
      await this.getSubCollection(FirebaseCollection.OPERATING_HOUR, 'appointmentTimes', times.length);
    } catch (error) {
      console.log(error);
    }
  }

  public async getSubCollection(id: string, subCollection: string, count: number): Promise<any> {
    try {
       await this.getSubColl(id, subCollection, count);
      setTimeout(async ()=>{ await this.updateInBulk(this.entities)},1000);
    } catch (error) {
      console.log(error);
    }
  }

  async getSubColl(id: string, subCollection: string, count: number) {
    this._angularFirestore
      .collection(FirebaseCollection.CLINIC)
      .doc(id)
      .collection(subCollection, ref => ref.orderBy('createdOnDate', 'desc').limit(count)).get()
      .subscribe(response => {
        for (const item of response.docs) {
          let obj: any = {};
          obj = { ...item.data() };
          obj.id = item.id;
          this.entities.push(obj);
        }
      });
  }

  async updateInBulk(times: any) {
    try {
      console.log(this.entities);
      const batch = this._angularFirestore.firestore.batch();
      times.forEach(async (doc: any) => {
        const userRef = this._angularFirestore
          .collection(FirebaseCollection.CLINIC)
          .doc(FirebaseCollection.OPERATING_HOUR)
          .collection('appointmentTimes')
          .doc(doc.id)
          .ref;
        batch.set(userRef, { ...doc });
      });
      await batch.commit();
    } catch (error) {
      console.log(error);
    }
  }


}
